<template>
  <div>

    <h2>{{ $t('title.' + action + '.person') }}</h2>
    <el-row :gutter="40">

      <el-col :span="12" :md="12" :sm="24" :xs="24">

        <person-form :person="person" />

      </el-col>

    </el-row>
  </div>
</template>

<script>
import PersonForm from './PersonForm'

export default {
  name: 'person-details',
  computed: {
    person () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true }
      }

      return this.$store.getters['persons/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.person.new ? 'create' : 'edit'
    }
  },
  components: {
    PersonForm
  }
}
</script>



// WEBPACK FOOTER //
// PersonDetails.vue?0425e2cf